import React, { FC } from 'react'
// @ts-ignore
import { BrowserRouter } from 'react-router-dom'
// @ts-ignore
import { HashLink } from 'react-router-hash-link'
import { FinancialStrengthProps } from './FinancialStrength.types'
import './FinancialStrength.scss'
import { sanitizeHTML, utilizeScroll } from '../../utils/common-utils'

export const FinancialStrength: FC<FinancialStrengthProps> = props => {
  const { content } = props
  const {
    backgroundImageUrl,
    boxOneHeading,
    boxOneLeftContent,
    boxOneRightContent,
    boxTwoLeftContent,
    boxTwoRightContent,
    boxThreeContent,
    sourceInfoText,
    sourceInfoUrl,
  } = content

  return (
    <BrowserRouter>
      <div className='u-adel-reset financial-strength' id='financial-strength'>
        <div className='Content'>
          <div
            className='u-paddingVert80 u-sm-paddingVert40 u-bgSizeCover'
            style={{
              backgroundImage: `url(${backgroundImageUrl})`,
            }}>
            <div className='u-sizeConstrained fs-box'>
              <div className='Content Content--reversed'>
                <div className='u-flexCol u-md-flexCol u-sm-flexCol u-marginTop80 u-paddingHoriz40 u-paddingVert48 u-sm-paddingHoriz8'>
                  <div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHTML(boxOneHeading),
                      }}></div>
                    <div className='border-bottom u-flex u-md-flexCol u-sm-flexCol u-paddingBottom32 u-md-paddingBottom0 u-sm-paddingBottom0'>
                      <div className='u-size1of2 u-md-sizeFull u-sm-sizeFull'>
                        {boxOneLeftContent && (
                          <div className='u-flex u-flexCol u-flexAlignItemsCenter'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: sanitizeHTML(boxOneLeftContent),
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className='u-size1of2 u-md-sizeFull u-sm-sizeFull'>
                        {boxOneRightContent && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(boxOneRightContent),
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='u-flex u-md-flexCol u-sm-flexCol u-marginBottom20'>
                    <div className='returns-container u-flex u-sm-flexCol u-marginVert24'>
                      <div className='returns-content border-md-right u-paddingRight40 u-sm-paddingRight0 u-sm-paddingBottom20'>
                        {boxTwoLeftContent && (
                          <div
                            className=''
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(boxTwoLeftContent),
                            }}
                          />
                        )}
                      </div>
                      <div className='returns-content u-paddingLeft40 u-sm-paddingLeft0 u-sm-paddingTop20'>
                        {boxTwoRightContent && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(boxTwoRightContent),
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {boxThreeContent && (
                    <div
                      className='u-padding20'
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHTML(boxThreeContent),
                      }}
                    />
                  )}
                </div>
                <div className='u-flex u-flexJustifyEnd u-paddingVert20'>
                  <HashLink
                    className='u-md-textSizeMsrp2 u-sm-textSizeMsrp2 u-textSizeMsrp2'
                    scroll={(el: any) => utilizeScroll(`#${sourceInfoUrl}`, 100)}
                    to={`#${sourceInfoUrl}`}>
                    {sourceInfoText}
                  </HashLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  )
}
